"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _excluded = ["align", "className", "files", "setPdfOpen", "text", "key"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      margin: '2px 0px 4px 0px',
      padding: 0,
      // boxShadow: theme.shadows[1],
      backgroundColor: '#eee',
      '&:hover': {
        cursor: 'pointer'
      },
      maxWidth: '100%'
    },
    margin: {
      marginBottom: 4
    },
    list: {
      width: '100%'
    },
    listItem: {
      maxWidth: '100%'
    }
  };
});

var ChatDocument = function ChatDocument(_ref) {
  var align = _ref.align,
      className = _ref.className,
      files = _ref.files,
      setPdfOpen = _ref.setPdfOpen,
      text = _ref.text,
      key = _ref.key,
      other = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Rounded, _extends({
    align: align,
    className: (0, _classnames["default"])(classes.root, className)
  }, other), /*#__PURE__*/_react["default"].createElement(_core.List, {
    className: (0, _classnames["default"])(classes.list)
  }, files.map(function (_ref2) {
    var fileUrl = _ref2.fileUrl,
        label = _ref2.label;
    return /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
      classes: {
        root: (0, _classnames["default"])(classes.listItem)
      },
      interactive: true,
      label: label,
      fileUrl: fileUrl,
      onClickOpen: function onClickOpen() {
        return setPdfOpen(fileUrl);
      },
      onClickDownloadFile: function onClickDownloadFile() {
        return window.open(fileUrl, '__blank');
      }
    });
  }))), text && /*#__PURE__*/_react["default"].createElement(_solarReact.ChatText, {
    key: key,
    color: align === 'right' ? 'primary' : null,
    align: align,
    component: _solarReact.Rounded,
    className: (0, _classnames["default"])(classes.margin, align === 'right' && classes.colorPrimary)
  }, text));
};

ChatDocument.propTypes = {
  align: _propTypes["default"].string,
  classes: _propTypes["default"].object.isRequired,
  className: _propTypes["default"].string
};
ChatDocument.defaultProps = {
  className: ''
}; // prettier-ignore

var _default = ChatDocument;
exports["default"] = _default;